"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _reactstrap = require("reactstrap");

var _config = _interopRequireDefault(require("@dom/config"));

var _utils = require("@dom/utils");

var _Link = _interopRequireDefault(require("./Link"));

var _UserDropdown = _interopRequireDefault(require("./UserDropdown"));

var _FlightsDropdown = _interopRequireDefault(require("./FlightsDropdown"));

var _Cart = _interopRequireDefault(require("./Cart"));

var navBarMobileLogo = "".concat(_config["default"].ASSETS_URL, "/test/honeyguide.png");
var styles = {
  menuList: {
    flexDirection: 'row'
  }
};

var NavbarMobile = function NavbarMobile(props) {
  var userInfo = props.userInfo;
  var isUserLoggedIn = userInfo && Boolean(userInfo.userId);
  var goToGuideListings = _utils.makeUrl.goToGuideListings,
      goToTreks = _utils.makeUrl.goToTreks,
      goToLodge = _utils.makeUrl.goToLodge,
      goToTransportation = _utils.makeUrl.goToTransportation;
  return _react["default"].createElement(_reactstrap.Navbar, {
    color: "faded",
    light: true,
    className: "bg-white mobile mobile-nav"
  }, _react["default"].createElement(_reactstrap.NavbarBrand, {
    className: "mobile-brand",
    href: "/"
  }, _react["default"].createElement("img", {
    src: navBarMobileLogo,
    height: "53",
    alt: "navbar"
  })), _react["default"].createElement(_reactstrap.Nav, {
    className: "menu-list",
    navbar: true,
    style: styles.menuList
  }, _react["default"].createElement(_Link["default"], {
    linkTo: goToTreks,
    linkIcon: "tour.svg",
    useAnchor: true,
    title: "Tours"
  }), _react["default"].createElement(_FlightsDropdown["default"], null), _react["default"].createElement(_Link["default"], {
    linkTo: goToLodge,
    linkIcon: "lodge.svg",
    useAnchor: true,
    title: "Lodges"
  }), _react["default"].createElement(_Link["default"], {
    linkTo: goToGuideListings,
    linkIcon: "guide.svg",
    useAnchor: true,
    active: true,
    title: "Guides"
  }), _react["default"].createElement(_Link["default"], {
    linkTo: goToTransportation,
    linkIcon: "transport.svg",
    useAnchor: true,
    title: "Transports"
  })), _react["default"].createElement(_reactstrap.Nav, {
    className: "menu-list",
    navbar: true,
    style: styles.menuList
  }, _react["default"].createElement(_reactstrap.NavItem, null, _react["default"].createElement(_UserDropdown["default"], (0, _extends2["default"])({
    isUserLoggedIn: isUserLoggedIn
  }, props)))));
};

var _default = NavbarMobile;
exports["default"] = _default;